import { Mtds, templates, widgets } from 'prove-common'
import { Form, validator, type RJSFSchema } from 'prove-common/rjsf'
import type { useTaskReceptionAddress } from '../../hooks/useTaskReceptionAddress'

type Props = {
  query: ReturnType<typeof useTaskReceptionAddress>
  value?: number | null
  onChange: (value: number | null) => void
  disabled?: boolean
}

export const TaskReceptionAddress = ({
  query,
  value,
  onChange,
  disabled
}: Props) => {
  if (query.isPending) return <p role='status'>Laster mottaksadresser...</p>
  if (query.isError) {
    return (
      <Mtds.Alert as='div' role='alert' data-color='danger'>
        <p>
          Kunne ikke laste mottaksadressene. Prøv igjen før du lagrer oppgaven.
        </p>
        <Mtds.Button
          type='button'
          data-variant='secondary'
          disabled={query.isFetching}
          onClick={() => void query.refetch()}
        >
          Prøv igjen
        </Mtds.Button>
      </Mtds.Alert>
    )
  }
  if (query.data.length === 0) {
    return <p>Ingen mottaksadresser er registrert for laboratoriet.</p>
  }
  const schema: RJSFSchema = {
    type: 'object',
    properties: {
      labReceptionAddressId: {
        type: 'number',
        title: 'Mottaksadresse',
        description: 'Velg adressen prøvene skal sendes til',
        oneOf: query.data.map((address) => ({
          const: address.id,
          title: `${address.name}: ${address.addressLine1}${address.addressLine2 ? `, ${address.addressLine2}` : ''}, ${address.postalCode} ${address.city}, ${address.countryCode}${address.isDefault ? ' (standard)' : ''}`
        }))
      }
    },
    required: ['labReceptionAddressId']
  }
  return (
    <Form
      noHtml5Validate
      schema={schema}
      uiSchema={{ labReceptionAddressId: { 'ui:widget': 'SelectWidget' } }}
      widgets={widgets}
      templates={templates}
      validator={validator}
      showErrorList={false}
      disabled={disabled}
      formData={{ labReceptionAddressId: value ?? undefined }}
      experimental_defaultFormStateBehavior={{ constAsDefaults: 'skipOneOf' }}
      onChange={({ formData }) =>
        onChange(formData?.labReceptionAddressId ?? null)
      }
    >
      <></>
    </Form>
  )
}
